<template>
  <div class="show-box">
    <div
        v-if="value.value !== undefined"
        :class="value.value.toString()"
        class="value"
    >
      <status-icon :value="value.value"/>
      {{ value.text }}
    </div>
  </div>
</template>


<script lang="ts" setup>
import {computed, defineProps} from 'vue';
import {ToggleFieldType} from '@/components/business/crud/interface/FieldType';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import StatusIcon from '@/components/business/crud/common/StatusIcon.vue';
import { ColumnEdit } from '@/components/business/crud/widgets/TableWidgetContainer';

const props = defineProps<{
  columnEdit?: ColumnEdit;
  propName: string;
  widget: ToggleFieldType;
  info: WidgetInfo;
  data: any;
}>();

const value = computed(() => {
  if (props.data[props.propName] === undefined) {
    return {text: '', value: undefined};
  } else if (props.data[props.propName] === true) {
    return {text: props.widget.trueText || "是", value: true};
  } else {
    return {text: props.widget.falseText || "否", value: false};
  }
})
</script>

<style lang="scss" scoped>
.show-box {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  .value {
    display: flex;
    flex-direction: row;
    align-items: center;

    &.true {
      color: $color-success;
    }

    &.false {
      color: $color-danger;
    }
  }
}
</style>
